export const novelLemoncasualhub = {
    lang: 'en',
    company: 'lemoncasualhub.com',
    name: 'Lemoncasualhub',
    email: 'jannatjahan36487@gmail.com',
    fbPixel: {
        1: '1438847163760449',
    },
    adx: {
        1: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_1',
        2: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_2',
        3: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_3',
        4: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_4',
        5: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_5',
        6: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_6',
        7: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_7',
        8: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_8',
        9: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_9',
        10: '/23301273326,23311063535/HK_CN_novel.lemoncasualhub.com_gc_banner_10',
    },
    ga4: {
        id: 'G-YTGCHY7BZY'
    },
    adConfig: {
        default: {
            // 关闭遮罩时间
            closeMaskTime: 20000,
            // 倒计时时间
            time: 400,
            // 20s 计数
            interTime: 20,
            // 是否可以点击穿透
            // 点击广告上线
            clickMax: 20,
        }
    },
    content:{
        1: {
            split: '\n\n',
            textNum: 300,
            p: 3,
        },
    },
    pixelReport: {
        default: {
            chapter: new Set([1, 3, 5, 10, 20, 30]),
            rate: 0.6
        }
    }
}